import React from 'react';
import { Check } from 'lucide-react';
import subscriptionData from '../../../../../data/subscription/subscriptionData.json';

const CATEGORY_LABELS = subscriptionData.categoryLabels;

const renderFeatureValue = (feature) => {
  const value = feature?.value || (feature?.included ? '✓' : '—');
  if (feature?.included && (value === '✓' || value.toLowerCase() === 'yes')) {
    return <Check className="w-4 h-4 text-[#067978] stroke-[2.75]" aria-label="Included" />;
  }
  if (value === '✗' || value === '✕' || value === '—') {
    return <span className="text-slate-300">—</span>;
  }
  return <span className="text-[11px] leading-4 text-slate-600 text-center">{value.replace(/^✓\s*/, '')}</span>;
};

const SubscriptionComparisonTable = ({ plans, categories, getFeature }) => {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden mb-8">
      <div className="px-5 sm:px-6 py-5 border-b border-slate-100 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
        <div>
          <h2 className="text-xl font-semibold text-slate-900">Everything, side by side</h2>
          <p className="mt-1 text-sm text-slate-500">Compare what&apos;s included in every plan at a glance.</p>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="bg-slate-50 border-b border-slate-200 text-left">
            <tr>
              <th className="sticky left-0 z-10 bg-slate-50 px-5 sm:px-6 py-3 font-semibold text-slate-700 min-w-[200px]">Features</th>
              {plans.map((plan) => (
                <th key={plan._id} className="px-4 py-3 text-center font-semibold text-slate-700 min-w-[120px]">
                  {plan.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {categories.map(({ category, features }) => (
              <React.Fragment key={category}>
                <tr>
                  <td colSpan={plans.length + 1} className="px-5 sm:px-6 py-2.5 bg-teal-50/70 text-[10px] font-bold uppercase tracking-[0.12em] text-[#067978]">
                    {CATEGORY_LABELS[category] || category}
                  </td>
                </tr>
                {features.map((feature) => (
                  <tr key={`${feature.category}-${feature.name}`} className="border-b border-slate-100 last:border-0">
                    <td className="sticky left-0 z-10 bg-white px-5 sm:px-6 py-3 text-slate-600">
                      {feature.name}
                    </td>
                    {plans.map((plan) => (
                      <td key={plan._id} className="px-4 py-3 text-center">
                        <span className="inline-flex min-h-4 items-center justify-center">
                          {renderFeatureValue(getFeature(plan, feature))}
                        </span>
                      </td>
                    ))}
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default SubscriptionComparisonTable;
